import { AsyncActionState } from '@telstra-connect/standard-actions/async-action';
import {
    ICommonDates,
    IPaginationParameters
} from './common';

export enum OrderStatus {
    AtRisk = 'Potential delay',
    Delayed = 'Delayed',
    OnTrack = 'On track',
    Complete = 'Completed',
    Withdrawn = 'Withdrawn',
    Unknown = '',
    Fulfilled = 'Fulfilled',
    WithdrawnInProgress = 'Withdrawn in progress'
}

export const orderSort = {
    status: {
        default: 'status:default',
        asc: 'status:asc',
        desc: 'status:desc'
    }
}

export const orderApiSort = {
    'status:asc': '+status',
    'status:desc': '-status',
    'status:default': '++status'
}

export const defaultSortOrder = {
    number: 'asc',
    name: 'asc',
    ncp: 'asc',
    location: 'asc',
    status: 'asc',
    siteComplete: 'asc',
    estimatedDelivery: 'asc',
    closedDate: 'asc'
}

export const orderListDefaultColumns = {
    number: 'Number',
    name: 'Name',
    ncp: 'Secondary reference',
    location: 'Location',
    status: 'Status',
    sitesComplete: 'Sites Complete',
    estimatedDelivery: 'Estimated',
    closedDate: 'Completed',
    supportEnquiry: '',
    yourReference: 'Your order reference',
    projectManager: 'Project manager'
}

export const tabViewOrdersDefaultColumns = {
    number: 'Order number',
    ncp: 'Secondary reference',
    status: 'Order status',
    estimatedDelivery: 'Order estimated',
    requiredDelivery: 'Order required',
    sitesComplete: 'Sites completed',
    closedDate: 'Order completed',
    customerName: 'Customer',
    cidn: 'Customer ID',
    supportEnquiry: '',
    yourReference: 'Your order reference',
    projectManager: 'Project manager'
}

export const tabViewLocationDefaultColumns = {
    id: 'Id',
    name: 'Product',
    productType: 'Product type',
    productStatus: 'Product status',
    siteAddress: 'Site address',
    siteName: 'Site name',
    productEstimatedDelivery: 'Product estimated',
    productRequiredDelivery: 'Product required',
    upcomingAppointment: 'Upcoming appointment',
    productClosedDate: 'Product completed',
    number: 'Order number',
    ncp: 'Secondary reference',
    customerName: 'Customer',
    cidn: 'Customer ID',
    supportEnquiry: '',
    yourReference: 'Your order reference',
    projectManager: 'project Manager',
    deliveryAddress: 'Delivery address'
}

export const tabViewLocationIntDefaultColumns = {
    Icon: 'Icon',
    name: 'Product',
    serviceId: 'Service ID',
    productType: 'Type',
    productStatus: 'Product status',
    siteAddress: 'Site address',
    productEstimatedDelivery: 'Product estimated',
    productRequiredDelivery: 'Product required',
    productClosedDate: 'Product completed',
    billing: 'Billing',
    number: 'Order number',
    ncp: 'Secondary reference',
    customerName: 'Customer',
    cidn: 'Customer ID',
    supportEnquiry: '',
    yourReference: 'Your order reference',
    projectManager: 'project Manager'
}

export const columnsToCreateForLocationsTab = [
    { label: 'Product', value: 'name' },
    { label: 'Product type', value: 'productType' },
    { label: 'Product status', value: 'productStatus' },
    { label: 'Site address', value: 'siteAddress' },
    { label: 'Site name', value: 'siteName' },
    { label: 'Product estimated ', value: 'productEstimatedDelivery' },
    { label: 'Product required', value: 'productRequiredDelivery' },
    { label: 'Upcoming appointment', value: 'upcomingAppointment' },
    { label: 'Product completed', value: 'productClosedDate' },
    { label: 'Order number', value: 'number' },
    { label: 'Secondary reference', value: 'ncp' },
    { label: 'Customer', value: 'customerName' },
    { label: 'Customer ID', value: 'cidn' },
    { label: 'Delivery address', value: 'deliveryAddress' }
]
export const columnsToCreateForLocationsIntTab = [
    { label: 'Product', value: 'name' },
    { label: 'Service ID', value: 'serviceId' },
    { label: 'Type', value: 'productType' },
    { label: 'Product status', value: 'productStatus' },
    { label: 'Site address', value: 'siteAddress' },
    { label: 'Product estimated', value: 'productEstimatedDelivery' },
    { label: 'Product required', value: 'productRequiredDelivery' },
    { label: 'Product completed', value: 'productClosedDate' },
    { label: 'Billing', value: 'billing' },
    { label: 'Order number', value: 'number' },
    { label: 'Secondary reference', value: 'ncp' },
    { label: 'Your order reference', value: 'yourReference' },
    { label: 'Customer', value: 'customerName' },
    { label: 'Customer ID', value: 'cidn' }
]

export const columnsToCreateForOrdersTab = [
    { label: 'Order number', value: 'number' },
    { label: 'Secondary reference', value: 'ncp' },
    { label: 'Order status', value: 'status' },
    { label: 'Order estimated', value: 'estimatedDelivery' },
    { label: 'Order required', value: 'requiredDelivery' },
    { label: 'Sites completed', value: 'sitesComplete' },
    { label: 'Order completed', value: 'closedDate' },
    { label: 'Customer', value: 'customerName' },
    { label: 'Customer ID', value: 'cidn' }
]

export const columnsToCreateForOrdersTabInt = [
    { label: 'Order number', value: 'number' },
    { label: 'Secondary reference', value: 'ncp' },
    { label: 'Order status', value: 'status' },
    { label: 'Order estimated', value: 'estimatedDelivery' },
    { label: 'Order required', value: 'requiredDelivery' },
    { label: 'Order completed', value: 'closedDate' },
    { label: 'Your order reference', value: 'yourReference' },
    { label: 'Project manager', value: 'projectManager' },
    { label: 'Customer', value: 'customerName' },
    { label: 'Customer ID', value: 'cidn' }
]

export const defaultColumnsSelected = ['number', 'ncp', 'status', 'estimatedDelivery',
    'requiredDelivery', 'sitesComplete', 'closedDate', 'customerName', 'cidn']

export const defaultColumnsSelectedInt = ['number', 'ncp', 'yourReference', 'status', 'estimatedDelivery',
    'requiredDelivery', 'closedDate', 'projectManager', 'customerName', 'cidn']

export const columnsToCreateForOrders = [
    { label: 'Number', value: 'number' },
    { label: 'Secondary reference', value: 'ncp' },
    { label: 'Name', value: 'name' },
    { label: 'Location', value: 'location' },
    { label: 'Status', value: 'status' },
    { label: 'Site completed', value: 'sitesComplete' },
    { label: 'Estimated', value: 'estimatedDelivery' },
    { label: 'Completed', value: 'closedDate' },
    { label: 'Your order reference', value: 'yourReference' },
    { label: 'Project manager', value: 'projectManager' }
]

export const orderListTabs = ['Orders', 'Locations']

export const sortParamMapping = (param: string): string => {
    if (param) {
        if (param.endsWith(':asc')) {
            return `+${param.replace(':asc', '')}`;
        } else if (param.endsWith(':desc')) {
            return `-${param.replace(':desc', '')}`;
        } else if (param.startsWith('++')) {
            return `${param.replace('++', '')}:default`;
        } else if (param.startsWith('+')) {
            return `${param.replace('+', '')}:asc`;
        } else if (param.startsWith('-')) {
            return `${param.replace('-', '')}:desc`;
        } else {
            return param;
        }
    } else {
        return '';
    }
}

export interface ILocationOrder {
    name: string;
    productType: string;
    productStatus: string;
    siteAddress: string;
    siteName: string;
    productEstimatedDelivery: string;
    productRequiredDelivery: string;
    upcomingAppointment: string;
    productClosedDate: string;
    number: string;
    ncp?: string;
    yourReference?: string;
    customerName: string;
    cidn: string;
    offer?: string;
    deliveryAddress?: string;
    location?: string;
    billing?: string;
    serviceId?: string;
    submittedToSDDate?: string;
}

export interface IOrder extends ICommonDates {
    cidn: string;
    number: string;
    name: string;
    products?: IProduct[];
    isMultiSiteOrder: boolean;
    sitesComplete: string;
    siteLocation: ISiteLocations[];
    filterLocation: ILocationsToSearch[];
    progressStage?: string;
    status: OrderStatus;
    singleSiteOrderSiteId?: string;
    ncp?: string;
    title?: string;
    sortOrder?: number;
    customerName?: string;
    yourReference?: string;
    projectManager?: string;
    siteName?: string;
    submittedToSDDate?: string;
}

export interface IProduct {
    name: string,
    productStatus: string,
    productType: string,
    offer?: string,
    location: string,
    productEstimatedDelivery: string,
    productRequiredDelivery: string,
    upcomingAppointment: string,
    productClosedDate?: string,
    deliveryAddress?: string,
    billing?: string,
    fnn?: string
    siteName?: string,
}

export interface IOrderIntV2 extends ICommonDates, IProduct {
    cidn: string;
    orderNumber: string;
    name: string;
    products?: IProduct[];
    isMultiSiteOrder: boolean;
    sitesComplete: string;
    siteLocation: ISiteLocations[];
    filterLocation: ILocationsToSearch[];
    progressStage?: string;
    orderStatus: OrderStatus;
    singleSiteOrderSiteId?: string;
    ncp?: string;
    title?: string;
    sortOrder?: number;
    customerName: string;
    yourReference?: string;
    projectManager?: string;
    siteName?: string;
    submittedToSDDate?: string;
    productStatus: string,
    productType: string,
    offer?: string,
    location: string,
    productEstimatedDelivery: string,
    productRequiredDelivery: string,
    upcomingAppointment: string,
    productClosedDate?: string,
    deliveryAddress?: string,
    billing?: string,
    fnn?: string
}
export interface IFlattenedProductRow extends IProduct {
    orderNumber: string;
    cidn: string;
    customerName: string;
    projectManager: string;
    yourReference: string;
    orderStatus: string;
    submittedToSDDate: string;
    estimatedDelivery: string;
    requiredDelivery: string;
    ncp?: string
}
export interface ISiteLocations {
    suburb: string;
    state: string;
}

export interface IOrdersSearchFilter {
    orders?: IOrdersSearch;
    orderDetailsSummary?: IOrderDetailsSummarySearch;
}
export interface IOrderDetailsSummarySearch {
    original?: IOrderDetailsSummarySearchFilter;
    filters?: IOrderDetailsSummarySearchFilter;
}
export interface IOrderDetailsSummarySearchFilter {
    status: IStatusToSearch[];
}
export interface IStatusToSearch {
    value: string;
    label: string;
    id?: string;
    name?: string;
    checked?: boolean;
    disabled?: boolean;
}
export interface IOrdersSearch {
    searchString?: string;
    original?: ISearchFilter;
    filters?: ISearchFilter;
    isInternational?: boolean;
}

export interface ISearchFilter {
    location: ILocationsToSearch[];
    status: IStatusToSearch[];
    productName: IProductsToSearch[];
    dateRange: string[];
}
export interface ILocationsToSearch {
    value: string;
    label: string;
}

export interface IPaginationOrder {
    active?: string,
    pageSizeActive?: number,
    paginationActive?: number,
    pageSizeOptions?: string[]
};

export interface IProductsToSearch {
    value: string;
    label: string;
}
export interface IOrdersResponse {
    orders?: IOrder[];
    isPartialResponse?: boolean;
    original_orders?: IOrder[];
    locationOrders?: ILocationOrder[];
    format_order_products?: IFlattenedProductRow[]
}

export interface ITabParams {
    sort?: string;
    selectedColumns?: string[];
    paginationOrder?: IPaginationOrder;
}

export interface ITabs {
    orders: ITabParams;
    locations: ITabParams;
}

export interface ILoadOrdersRequest {
    data: IOrdersResponse;
    status: AsyncActionState;
    error?: string;
    paginationParameters?: IPaginationParameters;
    tabs: ITabs;
}

export interface IActiveTabState {
    activeTab: activeTabState;
}

export type activeTabState = ActiveTabs.Orders | ActiveTabs.Locations;

export enum ActiveTabs {
    Orders = 'Orders',
    Locations = 'Locations'
}

export interface IDownloadCSVStatus {
    status: AsyncActionState;
}

/**
 *  international orders UI upliftment new state starts from here
 */
export interface IMultiselectOrderSearchIntCheckbox {
    id: string;
    value: string;
    label: string;
    checked?: boolean;
}

export interface IOrdersResponseV2 {
    orders?: IFlattenedProductRow[];
    isPartialResponse?: boolean;
    original_orders?: IOrderIntV2[];
}

export interface ILoadOrdersRequestV2 {
    data: IOrdersResponseV2;
    status: AsyncActionState;
    error?: string;
    paginationParameters?: IPaginationParameters;
}

export interface IOrdersIntV2SearchFilter {
    orders?: IOrdersIntV2Search;
}

export interface IOrdersIntV2Search {
    searchString?: string;
    original?: IOrdersIntV2Filters;
    filters?: IOrdersIntV2Filters;
    isInternational?: boolean;
}

export interface IOrdersIntV2Filters {
    location: IMultiselectOrderSearchIntCheckbox[];
    status: IStatusToSearch[];
    productName: IMultiselectOrderSearchIntCheckbox[];
    siteAddress: IMultiselectOrderSearchIntCheckbox[];
    dateRange: string[];
}
